export default "__VITE_ASSET__CPHkz$Es__"